import styled from "styled-components"

export const StyledOfferConentItem = styled.div`
  max-width: 974px;
  width: 100%;
  margin: 0 auto;
  padding: 0 40px;
  @media only screen and (max-width: 767px) {
    padding: 0 20px;
  }
`
